// react
import { useEffect, useRef } from "react";
// components
import OverLay from "../OverLay/OverLay";
// classnames
import ClassNames from "classnames";

const CardsModal = (props) => {
  // props
  const { close, classNames } = props;
  // refs
  const modalRef = useRef();

  useEffect(() => {
    document.body.style.overflow = "hidden";

    return () => {
      // Always restore body scroll when modal closes
      document.body.style.overflow = "";
      document.body.style.paddingRight = "";
    };
  }, []);
  return (
    <>
      <OverLay clicked={close} />
      <div
        className={ClassNames(
          "modal rounded-lg border border-light-gray bg-white w-10/12 sm:w-1/2 z-50 p-6",
          classNames
        )}
        ref={modalRef}
      >
        {props.children}
      </div>
    </>
  );
};
export default CardsModal;
